import { ActionOptions } from 'src/app/shared/interfaces/actionOption';
import { dateFormat } from '../../shared/functions/date.functions';
import { getPaymentState, getHTMLPaymentConcept } from '../../shared/functions/payments.functions';
import { DatePipe } from '@angular/common';
import { PaymentMethodTypeModel } from './payment-method-type.model';

export class PaymentModel {
  public balanceCuenta: number;
  public descripcion: string;
  public estado: string;
  public fecha: Date;
  public fechaAcreditacion: Date;
  public id: number;
  public mpTipo: PaymentMethodTypeModel;
  public nroTarjeta: null;
  public observaciones: string;
  public titulo: string;
  public actions?: ActionOptions[];
  public monto: number;
  public tipoMovimiento: string;
  public comprobanteDisponible: boolean;
  public imgId: number;
  public sucursal: string;
  public caja: string;
  public conceptoTipo?: string;
  public idMovOrigin: string;
  public referencia: number;
  public cuilCuitContraparte: string;
  public cvuContraparte: string;
  public billetera: string;
  public debinId: string;
  public importe: string | number;
  public medioPagoView: string;
  public netoAcreditado?: number;
  public terminalId?: string;
  public phoneClientPix?: string;
  public argExchangePix?: string;

  get getCvuContraparte(): string {
    return this.cvuContraparte;
  }

  get getBilletera(): string {
    return this.billetera;
  }

  get getCuilCuitContraparte(): string {
    return this.cuilCuitContraparte;
  }

  get _medioPagoView(): string {
    return this.mpTipo.nombre;
  }

  get _importe(): string {
    return this.monto
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&.')
      .replace(/.([^.]*)$/, ',$1');
  }

  get fechaFormat(): string {
    return dateFormat(this.fecha);
  }

  get fechaAcreditacionFormat(): string {
    var datePipe = new DatePipe('en-US');
    return (
      '<div class="text-label" style="font-weight: bold;">' +
      datePipe.transform(this.fechaAcreditacion, 'dd/MM/yyyy') +
      '</div>'
    );
  }

  get getTitulo(): string {
    return this.titulo;
  }

  get getDebinId(): string {
    return this.debinId;
  }

  constructor() {
    this.mpTipo = new PaymentMethodTypeModel();
  }

  public transform(): void {
    this.estado = getPaymentState(this.estado);
    this.titulo = getHTMLPaymentConcept(this.titulo, null, this.tipoMovimiento);

    this.actions = [
      <ActionOptions>{ id: 1, name: 'pageview', status: true, path: 'detail-pay', type: 'action' },
      <ActionOptions>{ id: 2, name: 'picture_as_pdf', status: false, type: 'action' },
      <ActionOptions>{ id: 3, name: 'delete', status: false, type: 'action' },
      <ActionOptions>{ id: 4, name: 'edit', status: false, type: 'action' },
      <ActionOptions>{ id: 5, name: 'save_alt', status: this.comprobanteDisponible, type: 'action' }
    ];
  }
}
